exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#containerSite[data-v-64ab6724],#containerSiteSpouse[data-v-64ab6724]{height:500px}", ""]);

// exports
